var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showButton),expression:"showButton"}],staticClass:"back-to-top-container"},[_c('van-button',{attrs:{"round":"","type":"primary","icon":"arrow-up","size":"small"},on:{"click":_vm.scrollToTop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }